export const IP_RESTRICTED_PATH = "/ip-restricted"

const IP_NOT_ALLOWED_TYPE = "/ip-not-allowed"
const IP_NOT_ALLOWED_CODE = "IP_NOT_ALLOWED"
const MESSAGE_STORAGE_KEY = "ip-restricted-message"

// ログイン前の画面ではページを移さず、その場で拒否の理由を伝える。
const BEFORE_SIGN_IN_PATHS = ["/signin", "/login", "/password-issue", "/password-reset"]

/** 業務 API は type、better-auth（ログイン・パスワード再設定）は code で拒否を返す。 */
export const isIpNotAllowedError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") {
    return false
  }
  const { type, code } = error as { type?: unknown; code?: unknown }
  return type === IP_NOT_ALLOWED_TYPE || code === IP_NOT_ALLOWED_CODE
}

export const isBeforeSignInPath = (pathname: string): boolean =>
  BEFORE_SIGN_IN_PATHS.some((path) => pathname.startsWith(path))

// 拒否された時点でサーバー側のセッションも失効するため、並行していたリクエストは 401 になる。
// 専用ページへの遷移が始まった後は、その 401 でトーストやサインインへの遷移を起こさない。
let leavingForIpRestriction = false

export const markLeavingForIpRestriction = () => {
  leavingForIpRestriction = true
}

export const isLeavingForIpRestriction = (): boolean => leavingForIpRestriction

// 専用ページは全画面の再読み込みで開くため、状態ではなく sessionStorage で理由を渡す。
export const saveIpRestrictedMessage = (message: string) => {
  sessionStorage.setItem(MESSAGE_STORAGE_KEY, message)
}

export const readIpRestrictedMessage = (): string | null =>
  sessionStorage.getItem(MESSAGE_STORAGE_KEY)

// 表示時に消すと StrictMode の再描画で理由が消えるため、ログインに成功した時点で消す。
export const clearIpRestrictedMessage = () => {
  sessionStorage.removeItem(MESSAGE_STORAGE_KEY)
}
